import React, { Component } from 'react'
import request from '../../../lib/requester'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import moment from 'moment'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ClaimSummaryCHD extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataTable: [],
      baseTable: [],
      loading: false,
      user: JSON.parse(window.localStorage.getItem('is_user')) || {}
    }
  }

  componentDidMount = () => {
    this.getDataSummary()
  }

  getDataSummary = () => {
    let url = '/api/traces_chd/v1/claim/data-summary-approval'

    this.setState({ loading: true })
    request.getCHD(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({ dataTable: data, baseTable: data, loading: false })
      }.bind(this),
      error: function(e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: 'CLAIM NO',
          accessor: 'claim_number',
          filterable: true
        },
        {
          Header: 'SKP NO',
          accessor: 'skp_number',
          filterable: true
        },
        {
          Header: 'REFF NO',
          accessor: 'ref_number',
          filterable: true
        },
        {
          Header: 'PROGRAM TYPE',
          accessor: 'program_type',
          filterable: true
        },
        {
          Header: 'DESCRIPTION',
          accessor: 'description',
          filterable: true
        },
        {
          Header: 'CLAIM EXP DATE',
          accessor: 'claim_exp_date',
          Cell: row => (
            <span>
              <span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss") : ""}
              </span>
            </span>
          )
        },
        {
          Header: 'SUBMITTED DATE',
          accessor: 'creation_date',
          Cell: row => (
            <span>
              <span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY HH:mm:ss") : ""}
              </span>
            </span>
          )
        },
        {
          Header: 'TOTAL',
          accessor: 'total',
          filterable: true,
          Cell: row => (
            <span>{ app.thousandSeparator(row.value)}</span>
          )
        },
        {
          Header: 'CUSTOMER',
          accessor: 'customer_name',
          filterable: true
        },
        {
          Header: '',
          accessor: 'claim_id',
          Cell: (row) => {
            return (
              <span>
                <button className="btn btn-info btn-sm" onClick={() => { this.goDetail(row) }}><i class="fas fa-eye"></i> View</button>
              </span>
            )
          }
        }
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
      defaultFilterMethod={((filter, row, column) => {
        let columnes = ""
        switch (filter.id) {
          case "start_date":
            columnes = row._original.formatted_start_date
            break;
          case "end_date":
            columnes = row._original.formatted_end_date
            break;
          case "claim_exp_date":
            columnes = row._original.formatted_exp_date
            break;
          case "creation_date":
            columnes = row._original.formatted_submitted_date
            break;
          default:
            columnes = row[filter.id]
        }

        return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
      })}
    />)
  }

  goDetail = (row) => {
    this.props.history.push('/admin/claim-chd/approval/' + row.value)
  }

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable
    let filename = 'claim-summary-' + moment(new Date()).format('DDMMYYYYHHmmss')

    return (
      <ExcelFile filename={filename} fileExtension="xls" element={(<button className="btn btn-success"><i className="fas fa-file-excel" />Export to excel</button>)}>
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="Claim Number" value="claim_number" />
          <ExcelColumn label="Traces Number" value="skp_number" />                    <ExcelColumn label="Skp Number" value="skp_number" />
          <ExcelColumn label="Ref No" value="ref_number" />
          <ExcelColumn label="Program Type" value="program_name" />
          <ExcelColumn label="Description" value="description" />
          <ExcelColumn label="Start Date" value="formatted_start_date" />
          <ExcelColumn label="End Date" value="formatted_end_date" />
          <ExcelColumn label="Claim Exp" value="formatted_claim_exp" />
          <ExcelColumn label="Submitted Date" value="creation_date" />
          <ExcelColumn label="Amount" value="total_claim" />
          <ExcelColumn label="Customer" value="customer_name" />
          <ExcelColumn label="Status" value="status" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  thousandSeparator = (value) => {
    if (value.length === 0) return

    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
  
  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-6 float-left">
                        <div className="row">
                          <div className="col-lg-12">
                            {/* {this.exportToExcel()} */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 float-right">
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ClaimSummaryCHD